<template>
  <div class="container">
    <h1 colass='hover' v-to="'/myregistrations'">Minha Inscrição</h1>

    <div v-if="this.error" class='alert alert-danger'>
                        {{ this.error }}
                </div>

    <div class="row" v-if="purshaseProduct">
      <div class="col-12 col-sm-8">
        <purshase-product-info-edit v-if="purshaseProduct" :purshaseProduct="purshaseProduct" :readonly="eventPassed" :key="'myregistrationinfo-'+id">
        </purshase-product-info-edit>
      </div>
      <div class="col-12 col-sm-4">

            <div v-if="gpxState" :class="['gpx-hero', 'gpx-hero--' + gpxState]">
              <div class="gpx-hero-icon">{{ gpxState === 'send' ? '📍' : '✓' }}</div>
              <h3 v-if="gpxState === 'send'">Envie o Tracklog da sua corrida</h3>
              <h3 v-else>Tracklog enviado</h3>
              <p v-if="gpxState === 'send'">A janela de envio está aberta. Comprove seu percurso enviando o arquivo da sua corrida.</p>
              <p v-else-if="gpxState === 'sent-open'">{{ gpxCount }} arquivo{{ gpxCount > 1 ? 's' : '' }} enviado{{ gpxCount > 1 ? 's' : '' }}. Você pode ver ou trocar enquanto a janela estiver aberta.</p>
              <p v-else>{{ gpxCount }} arquivo{{ gpxCount > 1 ? 's' : '' }} · envio encerrado.</p>
              <router-link
                :to="'/myregistrations/' + id + '/gpx'"
                class="gpx-hero-btn"
              >
                <span v-if="gpxState === 'send'">Enviar Tracklog da corrida →</span>
                <span v-else-if="gpxState === 'sent-open'">Ver ou alterar envios →</span>
                <span v-else>Ver meus envios →</span>
              </router-link>
            </div>

            <div v-if="resultReady" class="result-card">
              <div class="result-icon">🏅</div>
              <h3>Resultado</h3>
              <div v-if="purshaseProduct.resultStatus === 'finished'">
                <div class="result-time">{{ finishTime }}</div>
                <div class="result-plc">
                  <span v-if="purshaseProduct.overallPlacement != null">{{ purshaseProduct.overallPlacement }}º geral</span>
                  <span v-if="purshaseProduct.categoryPlacement != null"> · {{ purshaseProduct.categoryPlacement }}º na categoria</span>
                </div>
              </div>
              <div v-else class="result-time">{{ purshaseProduct.resultStatus === 'dq' ? 'Desclassificado' : 'Não concluído' }}</div>
              <button v-if="eventInfo && eventInfo.certificateEnabled && purshaseProduct.resultStatus === 'finished'"
                      class="result-btn" :disabled="certBusy" @click="downloadCertificate">
                {{ certBusy ? 'Gerando…' : 'Ver / baixar certificado →' }}
              </button>
            </div>

            <div v-if="purshaseProduct.payedByAdmin == true" class="alert alert-success">
                <h4> Equipe Inscrita com sucesso! </h4>
            </div>
            <order-paymentstatus v-else :allinfos="false" :orderid="purshaseProduct.orderId" />
      </div>
    </div>
    <!-- {{ purshaseProduct }} -->
  </div>
</template>


<script>
  import api from '@/api';

  export default {
    data(){
      return { error:false, eventInfo: null, gpxCount: null, certBusy: false }
    },

    created:async function () {
      //debugger;
      let res = await this.$store.dispatch('PurchaseStore/loadRegistrationsById',this.id)
          if(res == false){
                        this.error = "Ocorreu um Erro!"
                }
          await Promise.all([this.loadEventInfo(), this.loadGpxCount()])
    },

    watch:{
      id:async function(){
          this.error = false;
          this.eventInfo = null;
          this.gpxCount = null;
           let res = await this.$store.dispatch('PurchaseStore/loadRegistrationsById',this.id)
          if(res == false){
                        this.error = "Ocorreu um Erro!"
                }
           await Promise.all([this.loadEventInfo(), this.loadGpxCount()])
      }
    },

    computed: {
      id: function () {
        return parseInt(this.$route.params.id)
      },

      purshaseProduct: function () {
        return this.$store.getters['PurchaseStore/purshaseProductById'](this.id)
      },

      windowOpen: function () {
        if (!this.purshaseProduct || !this.eventInfo) return false;
        if (!this.eventInfo.uploadGPX) return false;
        const now = Date.now();
        const open = this.eventInfo.gpxUploadOpenAt
          ? new Date(this.eventInfo.gpxUploadOpenAt).getTime() : 0;
        const close = this.eventInfo.gpxUploadCloseAt
          ? new Date(this.eventInfo.gpxUploadCloseAt).getTime() : Infinity;
        return now >= open && now <= close;
      },

      isPaid: function () {
        return !!this.purshaseProduct
          && (this.purshaseProduct.payed === true || this.purshaseProduct.payedByAdmin === true);
      },

      // Estado do banner. null = não mostra (não paga, carregando, ou janela
      // fechada sem nenhum envio).
      gpxState: function () {
        if (!this.isPaid) return null;
        if (this.gpxCount === null || !this.eventInfo) return null;
        if (this.windowOpen) return this.gpxCount > 0 ? 'sent-open' : 'send';
        return this.gpxCount > 0 ? 'sent-closed' : null;
      },

      // The event has already happened (race date in the past) → athlete info
      // is locked for editing. Event.start holds the race date.
      eventPassed: function () {
        if (!this.eventInfo || !this.eventInfo.start) return false;
        return Date.now() > new Date(this.eventInfo.start).getTime();
      },

      // Resultado visível ao participante: publicado pelo admin + tem status.
      resultReady: function () {
        return !!this.eventInfo && this.eventInfo.resultsPublished === true
          && !!this.purshaseProduct && !!this.purshaseProduct.resultStatus;
      },
      finishTime: function () {
        const s = this.purshaseProduct && this.purshaseProduct.finishTimeSeconds;
        if (s == null || !isFinite(s)) return '—';
        const t = Math.round(Number(s));
        const h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), ss = t % 60;
        const p = (n) => String(n).padStart(2, '0');
        return h + ':' + p(m) + ':' + p(ss);
      },
    },

    methods: {
      async loadEventInfo() {
        const eventId = this.purshaseProduct && this.purshaseProduct.eventId;
        if (!eventId) return;
        const ev = await api.getJSONAsync('events/' + eventId);
        if (ev && !ev.error) this.eventInfo = ev;
      },

      // Abre a aba no clique (antes do await) para não cair no bloqueador de pop-up.
      async downloadCertificate() {
        const w = window.open('', '_blank');
        if (w) w.document.write('<p style="font-family:sans-serif;padding:2em;color:#555">Gerando certificado…</p>');
        this.certBusy = true;
        try {
          const r = await api.getJSONAsync('certificateGet', { purchaseProductId: this.id });
          if (!r || r.error || !r.html) throw new Error((r && r.message) || 'Certificado indisponível.');
          if (!w) throw new Error('O navegador bloqueou a nova aba. Permita pop-ups para este site.');
          w.document.open(); w.document.write(r.html); w.document.close();
        } catch (e) {
          if (w) w.close();
          alert(e.message || e);
        } finally {
          this.certBusy = false;
        }
      },

      async loadGpxCount() {
        const teamId = this.purshaseProduct
          && this.purshaseProduct.team
          && this.purshaseProduct.team[0]
          && this.purshaseProduct.team[0].id;
        if (!teamId) { this.gpxCount = 0; return; }
        try {
          const rows = await api.getJSONAsync('gpxListForTeam', { teamId });
          this.gpxCount = Array.isArray(rows) ? rows.length : 0;
        } catch (e) { this.gpxCount = 0; }
      },
    },

  }
</script>

<style>
.gpx-hero {
  margin-bottom: 1.4em;
  padding: 1.4em 1.2em;
  color: #fff;
  border-radius: 12px;
  text-align: center;
}
.gpx-hero--send {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
  box-shadow: 0 6px 18px rgba(23, 162, 184, 0.35);
}
.gpx-hero--sent-open {
  background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%);
  box-shadow: 0 6px 18px rgba(39, 174, 96, 0.35);
}
.gpx-hero--sent-closed {
  background: linear-gradient(135deg, #8a97a5 0%, #6b7a89 100%);
  box-shadow: 0 6px 18px rgba(107, 122, 137, 0.3);
}
.gpx-hero--sent-open .gpx-hero-btn { color: #1e8449; }
.gpx-hero--sent-closed .gpx-hero-btn { color: #55606b; }
.gpx-hero-icon {
  font-size: 2.2em;
  line-height: 1;
}
.gpx-hero h3 {
  margin: 0.3em 0 0.4em;
  color: #fff;
}
.gpx-hero p {
  margin: 0 0 1em;
  font-size: 0.92em;
  opacity: 0.95;
}
.gpx-hero-btn {
  display: inline-block;
  padding: 0.7em 1.4em;
  background: #fff;
  color: #138496;
  border-radius: 8px;
  font-weight: 700;
  text-decoration: none;
  transition: transform 0.1s;
}
.gpx-hero-btn:hover {
  transform: translateY(-1px);
  color: #0b5563;
}

.result-card {
  margin-bottom: 1.4em;
  padding: 1.2em;
  background: linear-gradient(135deg, #f6c343 0%, #e0a800 100%);
  color: #3d2f00;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 6px 18px rgba(224, 168, 0, 0.35);
}
.result-icon { font-size: 2.2em; line-height: 1; }
.result-card h3 { margin: 0.2em 0 0.4em; color: #3d2f00; }
.result-time { font-size: 1.6em; font-weight: 800; }
.result-plc { font-size: 1em; font-weight: 600; margin-top: 0.2em; }
.result-btn {
  margin-top: 1em;
  padding: 0.6em 1.2em;
  background: #3d2f00;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
}
.result-btn:hover { background: #241c00; }
</style>
